/// <amd-module name="Artifacts/Cargo/commands/Yank" />
import { CargoActions } from "Artifacts/Cargo/redux";
import { getYankCommandCreator } from "Artifacts/Root/protocols/Commands";

export const createYankCommand = getYankCommandCreator(CargoActions.changeListStatus);
